module.exports = __webpack_public_path__ + "static/media/04.e83ed126.mp3";